<template>
    <div>
        <v-server-table ref="FacilityTypeTable" url="/admin/facility-types-list" :columns="columns" :options="options">

            <router-link slot="FacilityTypeId" slot-scope="props" :to="`/incidents/settings/facility-types/edit/${props.row.FacilityTypeId}`" title="Edit Place of Treatment" class="btn btn-sm btn-secondary">
                <i class="fa fa-edit"></i> Edit
            </router-link>

            <template slot="IsActive" slot-scope="props">
                <label :class="`badge badge-${props.row.IsActive == 1 ? 'success' : 'warning'}`">
                    {{ props.row.IsActive == 1 ? 'Active' : 'Inactive' }}
                </label>
            </template>

        </v-server-table>
    </div>
</template>

<script>
    export default {
        data: function() {
            return {
                columns: ['FacilityTypeId', 'TypeName', 'Description', 'IsActive'],
                options: {
                    headings: {
                        FacilityTypeId: 'Edit',
                        TypeName: 'Place of Treatment',
                        IsActive: 'Status',
                    },
                    orderBy: {
                        ascending: true,
                        column: 'facilitytype.TypeName',
                    },
                    uniqueKey: 'FacilityTypeId',
                },
            }
        }
    }
</script>
